import {
  Pipe,
  PipeTransform
} from '@angular/core';
import { Store } from '@ngrx/store';
import { App, AppState } from '../../app.models';

@Pipe({ name: 'appcol' })
export class AppColPipe implements PipeTransform {
  transform(tags: App[]): string {
    return tags.map(t => t.name)
      .join(',')
  }
}

@Pipe({ name: 'appcolFromIds' })
export class AppColFromIdsPipe implements PipeTransform {
  apps: App[] = [];
  constructor(
    private store: Store,
  ) {
    this.store.select((state: AppState) => state.apps)
      .subscribe(apps => {
        this.apps = apps;
      });
  }
  transform(appIds: number[]): string {
    if (!appIds) {
      return 'n/a'
    }
    return appIds.map(id => this.apps.find(a => a.id === id)?.name || id).join(', ')
  }
}
